import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, OnInit, Input, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs';
import { ResizeService } from '../../../core/services/resize/resize.service';
import { ViewportService } from '@shared/common/services/viewport/viewport.service';

interface IDropDownHeights {
  tabletPortraitMaxHeight: number;
  tabletLandscapeMaxHeight: number;
  desktopMaxHeight: number;
}

@Directive({
  selector: '[appDropDownPosition]',
  standalone: false
})
export class DropDownPositionDirective implements OnInit, OnDestroy {
  windowScroll: number;
  elemOffsetTop: number;
  siteItem = this.document.getElementsByClassName('site').item(0) as HTMLElement;
  siteItemHeight: number;
  subscriptions: Array<Subscription> = [];
  @Input() appDropDownPosition: IDropDownHeights;

  constructor(
    public element: ElementRef,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly resizeService: ResizeService,
    private readonly viewportService: ViewportService,
    @Inject(PLATFORM_ID) public platformId: any
  ) {}

  ngOnInit() {
    this.siteItemHeight = this.siteItem?.offsetHeight ?? 0;
    this.checkElementHeightOptions();

    this.subscriptions.push(
      this.resizeService.resize().subscribe((size) => {
        this.checkElementHeightOptions();
      })
    );
  }

  checkElementHeightOptions() {
    this.elemOffsetTop = isPlatformBrowser(this.platformId)
      ? this.element.nativeElement.getBoundingClientRect().top
      : 0;
    this.windowScroll = window.scrollY;

    if (this.viewportService.isMobileDevice()) {
      this.element.nativeElement.style.height = '';
    } else if (this.viewportService.isTabletDevice()) {
      this.setElementHeight(this.appDropDownPosition.tabletLandscapeMaxHeight);
    } else {
      this.setElementHeight(this.appDropDownPosition.desktopMaxHeight);
    }
  }

  setElementHeight(assignedHeight) {
    if (this.elemOffsetTop + this.windowScroll + assignedHeight <= this.siteItemHeight) {
      this.element.nativeElement.style.height = assignedHeight + 'px';
    } else {
      this.element.nativeElement.style.height =
        this.siteItemHeight - this.elemOffsetTop - this.windowScroll - 20 + 'px';
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subs) => subs.unsubscribe());
  }
}
